import { Link, useLocation } from "react-router-dom";
import { Crosshair } from "lucide-react";

const Nav = () => {
  const { pathname } = useLocation();
  const home = pathname === "/";
  return (
    <header
      data-testid="site-nav"
      className="fixed top-0 inset-x-0 z-50 bg-background border-b border-border"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <span className="w-7 h-7 border border-foreground flex items-center justify-center">
            <Crosshair className="w-4 h-4 transition-transform duration-500 group-hover:rotate-90" />
          </span>
          <span className="font-display font-extrabold tracking-tight text-lg">GeoVerify</span>
          <span className="hidden sm:inline font-mono text-[10px] tracking-widest text-muted-foreground mt-0.5">
            TRUTH LAYER
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 font-mono text-[11px] tracking-[0.2em] uppercase">
          <a
            data-testid="nav-link-how"
            href={home ? "#how-it-works" : "/#how-it-works"}
            className="text-muted-foreground hover:text-foreground transition-colors duration-200"
          >
            Engine
          </a>
          <a
            data-testid="nav-link-api"
            href={home ? "#api" : "/#api"}
            className="text-muted-foreground hover:text-foreground transition-colors duration-200"
          >
            API
          </a>
          <Link
            data-testid="nav-link-playground"
            to="/playground"
            className="text-muted-foreground hover:text-foreground transition-colors duration-200"
          >
            Playground
          </Link>
          <Link
            data-testid="nav-link-geofences"
            to="/geofences"
            className="text-muted-foreground hover:text-foreground transition-colors duration-200"
          >
            Geofences
          </Link>
          <Link
            data-testid="nav-link-docs"
            to="/docs"
            className="text-muted-foreground hover:text-foreground transition-colors duration-200"
          >
            Docs
          </Link>
          <Link
            data-testid="nav-link-faq"
            to="/faq"
            className="text-muted-foreground hover:text-foreground transition-colors duration-200"
          >
            FAQ
          </Link>
        </nav>
        <a
          data-testid="nav-request-access-btn"
          href={home ? "#request-access" : "/#request-access"}
          className="bg-foreground text-background font-mono text-[11px] tracking-[0.2em] uppercase px-5 py-2.5 hover:bg-telemetry transition-colors duration-200"
        >
          Request Access
        </a>
      </div>
    </header>
  );
};

export default Nav;
